import { ICDV3ViewItem } from 'ui-toolkit/cdItems/interfaces/ICDViewItem';
import { sum } from '../../../ui-toolkit/utilities/sum';

const getAmounts = ({
  buyer_at_closing,
  buyer_before_closing,
  seller_at_closing,
  seller_before_closing,
  paid_by_others,
}: ICDV3ViewItem) => [buyer_at_closing, buyer_before_closing, seller_at_closing, seller_before_closing, paid_by_others];

export const addOriginalTotal = (item: ICDV3ViewItem) => ({ ...item, originalTotal: getAmounts(item).reduce(sum, 0) });
